import { CustomRulesController } from '../controller/CustomRulesController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class CustomRulesWebComponent extends BaseWebComponentElement {
  private _externalFilters: Array<any>;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: CustomRulesController,
    });
  }

  public set externalFilters(externalFilters) {
    this._externalFilters = externalFilters;
  }

  public get externalFilters() {
    return this._externalFilters ?? [];
  }
}
